import { render, staticRenderFns } from "./TestQuestionResult.vue?vue&type=template&id=5299d6da&scoped=true"
import script from "./TestQuestionResult.vue?vue&type=script&lang=js"
export * from "./TestQuestionResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5299d6da",
  null
  
)

export default component.exports